import React from "react";
import { Button, DialogActions, DialogContent, InputAdornment, TextField } from "@material-ui/core";
import GetCurrency from "../../helper/GetCurrency";
import { makeStyles } from "@material-ui/core/styles";
import { useDialog } from "../Dialogs/DialogProvider";
import withIntl from "../../utils/withIntl";
import { _post } from "../../Api";
import swal from "sweetalert";
import { toast } from "react-toastify";

const useStyles = makeStyles(() => ({
  rootActions: {
    justifyContent: "center",
  },
}));

function RefundDialog(props) {
  const classes = useStyles();
  const [amount, setAmount] = React.useState((props.amount / 100.0).toFixed(2));
  const [, closeDialog] = useDialog();

  return (
    <>
      <DialogContent>
        <TextField
          value={amount}
          type={"number"}
          onChange={(e) => {
            setAmount(e.target.value);
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">{GetCurrency()}</InputAdornment>,
          }}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.rootActions }}>
        <Button
          variant={"outlined"}
          color={"primary"}
          onClick={() => {
            closeDialog();
          }}
        >
          {props.intl.formatMessage({ id: "cancel" })}
        </Button>
        <Button
          variant={"contained"}
          color={"primary"}
          onClick={() => {
            _post("/nova/ta_merchant/" + props.taMerchantId + "/ta_receipt/" + props.taReceiptId + "/refund", {
              amount: Math.round(amount * 100),
            })
              .then((res) => {
                toast.success("Refunded", {
                  position: "bottom-right",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((e) => {
                swal({
                  title: "Oops!",
                  text: "Something went wrong.",
                  icon: "error",
                });
              });
            closeDialog();
          }}
        >
          {props.intl.formatMessage({ id: "refund" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(RefundDialog);
